module.exports = __webpack_public_path__ + "img/supply1.ecbba70a.jpg";